import React, { Component } from "react";
import { connect } from "react-redux";
import { redirectIfNoAccountInfo } from "../../../../domain/validation/validationActions";
import { startReferAuthorizedPerson, referAuthorizedPerson } from "../../../../domain/rpc/rpcActions";
import ReferForm from "../../../forms/public/ReferForm/ReferForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import styles from "./ReferAuthorizedUser.module.less";
import track from "react-tracking";
class ReferAuthorizedUser extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method. Redirects to landing page if required props aren't present
     * @method componentWillMount
     * @private
     */
    componentWillMount() {
        const { referenceNumber, pin } = this.props;
        this.props.redirectIfNoAccountInfo(referenceNumber, pin);
        this.props.startReferAuthorizedPerson(referenceNumber, pin);
    }
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className={process.env.FEATURE_PROBATE_CASE_SUBMISSION ? styles.wrapper : "wrapper wrapper_narrow"}>
				<StatusMessage isError isActive={this.props.error ? true : false} error={this.props.error ? this.props.error : null} customMessage={StatusMessages.VALIDATION.INTRO_REFER_AUTHORIZED_PARTY} domain="validation"/>
				<div className="vr vr_x4">
					<ReferForm fieldErrors={this.props.fieldErrors} pin={this.props.pin} refer={this.props.referAuthorizedPerson} referenceNumber={this.props.referenceNumber} isLoading={this.props.isLoading} error={this.props.error}/>
				</div>
				<StatusMessage isLoad isActive={this.props.isLoading}/>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    referenceNumber: state.validation.validationRequest ? state.validation.validationRequest.referenceNumber : null,
    pin: state.validation.validationRequest ? state.validation.validationRequest.pin : null,
    error: state.rpc.error,
    fieldErrors: state.rpc.fieldErrors,
    isLoading: state.rpc.isLoading
});
const bindActionsToProps = {
    redirectIfNoAccountInfo,
    referAuthorizedPerson,
    startReferAuthorizedPerson
};
/* Create and export container component that wraps ReferAuthorizedUser for property binding */
export default track({ page: "ReferAuthorizedUser" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ReferAuthorizedUser));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/ReferAuthorizedUser/ReferAuthorizedUser.tsx